export default import.meta.ROLLDOWN_FILE_URL_jHfQw3YiXlQn6kvXU2r0Zw